import { InfiniteData } from '@tanstack/query-core';

import { PaginatedResult } from './type';

export function composePaginatedData<T>({ data, limit }: { data: InfiniteData<PaginatedResult<T>>; limit?: number }) {
  const items = data.pages.map((it) => it.objects).flat();

  if (limit) {
    return items.slice(0, limit);
  }

  return items;
}
